module.exports = __webpack_public_path__ + "media/images/social-share-button/tumblr-f8a4150ddaa3f0ea69e5658a377e08ef.svg";